import React from 'react'
import { Helmet } from "react-helmet";
import './SiteMap.scss';
import CategoriesData from '../../Components/CategoriesData'
import CityList from '../../Components/CitiesData'

export default function SiteMap({ Companies = [] }) {
    return (
        <div className="SiteMap">
            <Helmet>
                <title>Site Map | HandyBy</title>
                <meta name="title" property="title" content="Site Map | HandyBy" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Site Map | HandyBy" data-react-helmet="true" />
                <meta name="description" content="Browse every page on HandyBy — categories, cities, pros, and more." data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.handyby.com/sitemap" />
                <link rel="canonical" href="https://www.handyby.com/sitemap" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className="SiteMapHero">
                <h1>HandyBy — Site Map</h1>
                <p>Find every page on handyby.com. <a href="/">Back to home</a></p>
            </div>

            <div className="SiteMapGrid">
                <section className="SiteMapSection">
                    <h2>Main Pages</h2>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/start-project">Start a Project</a></li>
                        <li><a href="/my-projects">My Projects</a></li>
                        <li><a href="/sign-up">Sign Up</a></li>
                        <li><a href="/login">Log In</a></li>
                    </ul>
                </section>

                <section className="SiteMapSection">
                    <h2>Service Categories ({CategoriesData.length})</h2>
                    <ul>
                        {CategoriesData.map((c, i) => (
                            <li key={i}>
                                <a href={`/category/${c.UrlCategory.toLowerCase()}`}>{c.Category}</a>
                                {" · "}
                                <a href={`/pros/${c.UrlCategory}`}>Top Pros</a>
                            </li>
                        ))}
                    </ul>
                </section>

                {Companies && Companies.length > 0 && (
                    <section className="SiteMapSection">
                        <h2>Featured Pros ({Companies.length})</h2>
                        <ul>
                            {Companies.map((c, i) => (
                                <li key={i}>
                                    <a href={`/pro/${c.nameUrl}`}>{c.name || c.nameUrl}</a>
                                </li>
                            ))}
                        </ul>
                    </section>
                )}

                <section className="SiteMapSection SiteMapSectionWide">
                    <h2>Service × City Landing Pages</h2>
                    <p className="SiteMapNote">Pick any category to see its city-by-city landing pages.</p>
                    <div className="SiteMapCategoryLinks">
                        {CategoriesData.map((c, i) => (
                            <a key={i} className="SiteMapCategoryLink" href={`/category/${c.UrlCategory.toLowerCase()}`}>
                                {c.Category} <span>→ in {CityList.length} cities</span>
                            </a>
                        ))}
                    </div>
                </section>

                <section className="SiteMapSection SiteMapSectionWide">
                    <h2>Service Areas ({CityList.length} cities)</h2>
                    <ul className="SiteMapColumns SiteMapColumnsCities">
                        {CityList.map((C, i) => (
                            <li key={i}>
                                <a href={`/category/air-duct/${C.url}`}>{C.City}, {C.StateID}</a>
                            </li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    )
}
